
import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/auth/AuthContext';

type ActivityLogPayload = {
  action: string;
  resourceType: string;
  resourceId?: string;
  details?: any;
};

export const useActivityLogger = () => {
  const { currentOrganization, user } = useAuth();

  const logActivity = useCallback(
    async (payload: ActivityLogPayload) => {
      if (!user) {
        console.log('Cannot log activity: No authenticated user');
        return;
      }
      
      // Skip logging if no organization is selected
      if (!currentOrganization || !currentOrganization.organization || !currentOrganization.organization.id) {
        console.log('Cannot log activity: No organization selected');
        return;
      }

      try {
        const { error } = await supabase.from('activity_logs').insert({
          organization_id: currentOrganization.organization.id,
          user_id: user.id,
          action: payload.action,
          resource_type: payload.resourceType,
          resource_id: payload.resourceId || null,
          details: payload.details || null,
        });

        if (error) {
          console.error('Error logging activity:', error);
        }
      } catch (error) {
        console.error('Failed to log activity:', error);
      }
    },
    [currentOrganization, user]
  );

  return { logActivity };
};
